module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2f1"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "22%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "78%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/illustrations#ill"
    }
  }, [_vm._v("List of Illustrations")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/foreword#for"
    }
  }, [_vm._v("Foreword")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc3"
  }, [_c('em', [_vm._v("Alfre Woodard")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_vm._v("Preface")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chronology#chr"
    }
  }, [_vm._v("Chronology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc4"
  }, [_c('strong', [_vm._v("PART")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01#part1"
    }
  }, [_vm._v("ONE")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01#part1"
    }
  }, [_vm._v("Blessed by Experiences")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1"
    }
  }, [_c('em', [_vm._v("1. Conversations with a Former President")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2"
    }
  }, [_c('em', [_vm._v("2. Courting the Superdelegates")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part02#part2"
    }
  }, [_vm._v("TWO")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part02#part2"
    }
  }, [_vm._v("A Blessed Beginning")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3"
    }
  }, [_c('em', [_vm._v("3. Inherited Values")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. A World without Blinders")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5. The Young Clyburns")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03#part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THREE")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03#part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding My Way")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("6. Into the Streets")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("7. Back to the Basics")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04#part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FOUR")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04#part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Charleston Shuffle")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("8. Two Steps to the West")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("9. Two Steps to the East")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("10. Two Steps Forward")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("11. One Step to the Rear")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part05#part5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIVE")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part05#part5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making History")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("12. Trailblazer")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("13. Myth Buster")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part06#part6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIX")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part06#part6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Racial Arbiter")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("14. The Chester Controversy")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("15. The Citadel Confrontation")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("16. The Conway Crisis")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("17. The Confederate Battle Flag")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part07#part7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEVEN")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part07#part7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coming to Grips with Reality")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("18. A Day of Reckoning")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("19. Reaffirming My Goals")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part08#part8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EIGHT")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part08#part8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dream Realized")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("20. Deciding to Run for Congress")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("21. Adventures in Campaigning")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("22. Primary Election Day, 1992")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("23. General Election, 1992")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part09#part9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NINE")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part09#part9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mr. Clyburn Goes to Washington")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("24. Arriving in Congress")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("25. Playing Hardball Clinton Style")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("26. My First Bill")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("27. Building Friendships")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part10#part10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEN")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part10#part10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Treading and Toiling")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("28. Wandering in the Wilderness")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("29. Principles above Politics")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("30. Service above Self")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part11#part11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ELEVEN")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part11#part11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Age of Obama")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("31. 3-V Day: Victory, Validation, Vindication")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("32. Barack and Me")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("33. Reforming Health Care")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("34. Reducing the Deficit")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part12#part12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWELVE")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part12#part12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blessed by the Past")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter35#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("35. Genuinely Southern")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("36. Proudly Black")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#epi",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Epilogue")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0